// Legacy route — redirect to unified /trash.
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/materials/trash")({
	beforeLoad: () => {
		throw redirect({ to: "/trash" });
	},
});
